/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Soubhagya Ghoshal",
  title: "Hi all, I'm Soubhagya",
  subTitle: emoji(
    "A passionate Full Stack & AI Engineer 🚀 having an experience of building Web applications, AI evaluation benchmarks, RAG pipelines, and scalable APIs using Python, JavaScript, and modern frameworks."
  ),
  resumeLink: "/resume.pdf", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/SoubhagyaGhoshal",
  linkedin: "https://www.linkedin.com/in/soubhagyaghoshal/",
  gmail: "soubhagyag73@gmail.com",

  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE FULL STACK & AI/ML ENGINEER FOCUSED ON SCALABLE AND RELIABLE SOLUTIONS",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    ),
    emoji("⚡ Architect full-stack applications with scalable REST APIs and secure authentication"),
    emoji(
      "⚡ Build robust AI/ML evaluation benchmarks, RAG pipelines, and conversational AI agents"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "AI/ML",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "Deep Learning",
      fontAwesomeClassname: "fas fa-project-diagram"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Narula Institute Of Techonology",
      logo: require("./assets/images/NIT.jpg"),
      subHeader: "Bachelor in Computer Science",
      duration: "September 2021 - June 2025",
      desc: "Participated in the research  and published 1 papers.",
      descBullets: [

      ]
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Turing",
      companylogo: require("./assets/images/turing_logo.jpg"),
      date: "Aug 2026 – Present",
      desc: "Develop and validate Python-based software across 2 core technologies, Python and Docker, with emphasis on correctness, reliability, and maintainability.",
      descBullets: [
        "Execute 3 validation activities testing, debugging, and verification to identify defects and confirm expected software behavior.",
        "Apply a 2-stage workflow of requirement analysis and implementation to solve engineering problems and deliver reliable software solutions.",
        "Review implementations across 3 quality dimensions code analysis, edge-case testing, and validation to strengthen solution robustness and consistency."
      ]
    },
    {
      role: "AI/ML Engineer",
      company: "Handshake",
      companylogo: require("./assets/images/handshake_logo.jpg"),
      date: "Jul 2026 – Aug 2026",
      desc: "Created and delivered 15+ AI evaluation benchmarks covering coding, reasoning, machine learning, data analysis, and software engineering workflows.",
      descBullets: [
        "Engineered 15+ Python reference implementations with deterministic validation using Pandas, NumPy, SciPy, and PyTest.",
        "Systematized benchmark execution across 3 engineering components GitHub Actions, Docker, and CI/CD testing improving reproducibility and reducing manual verification effort."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME RECENT PROJECTS I HAVE WORKED ON",
  projects: [
    {
      image: require("./assets/images/jervis_ai_1790057679964.jpg"),
      projectName: "Jervis – AI Voice Assistant",
      projectDesc: "Engineered an AI voice assistant supporting 20+ voice commands using speech recognition, NLP, conversational AI, and desktop automation.",
      footerLink: [
        {
          name: "View Repository",
          url: "https://github.com/SoubhagyaGhoshal"
        }
      ]
    },
    {
      image: require("./assets/images/ai_roadmap.png"),
      projectName: "AI Roadmap Generator",
      projectDesc: "Generates personalized learning roadmaps for various topics using AI.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://ai-roadmap-generator-three.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/chess_board_full.jpg"),
      projectName: "Chess",
      projectDesc: "A modern online chess platform with real-time multiplayer gameplay, multiple login options, and customizable board themes. Features include matchmaking, guest play, and a sleek dark mode interface.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://chess-frontend-olive.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/100xjobs.png"),
      projectName: "100xJobs",
      projectDesc: "A job board platform to help developers find high-paying jobs.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://100xjobs-nu.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/cliniva.png"),
      projectName: "Cliniva",
      projectDesc: "A comprehensive Hospital Management System built with React, Node.js, and MySQL. Features include role based access, appointment scheduling, patient records, and more.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://cliniva.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/weatherly.png"),
      projectName: "Weatherly",
      projectDesc: "Weatherly is a sleek and responsive weather forecasting app that provides real-time weather data, air quality index, UV index, and a 5-day forecast based on user location or search.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://weatherly-soubhagya.netlify.app/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Object-Oriented Data Structures in C++",
      subtitle:
        "An online non-credit course authorized by University of Illinois Urbana-Champaign and offered through Coursera",
      image: require("./assets/images/I.jpg"),
      imageAlt: "Object-Oriented Data Structures in C++ Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/15Jjm2m-0eDTL4tdrFqqhHb-jUQ9UmFOQ/view?usp=drivesdk"
        },

      ]
    },
    {
      title: "Machine Learning with Python",
      subtitle:
        "An online non-credit course authorized by IBM and offered through Coursera",
      image: require("./assets/images/IBM.png"),
      imageAlt: "Machine Learning with Python Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1eCxC4VUbKKviigZ2FAGt0W2e9-r22G-p/view?usp=drivesdk"
        }
      ]
    },

    {
      title: "Introduction to Cybersecurity",
      subtitle: "Completed Certification from Cisco",
      image: require("./assets/images/cisco_cybersecurity.png"),
      imageAlt: "Introduction to Cybersecurity Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/6539b4d4-484d-4f9a-9022-9e088c73e71f/linked_in_profile"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "A collection of links that I use to learn various topics/subjects such as computer science, privacy, security, AI and others.",
  displayMediumBlogs: false, // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://sujauddin.me/links",
      title: "A collection of links that I use to learn various topics/subjects.",
      description:
        "A collection of links that I use to learn various topics/subjects such as computer science, privacy, security, AI and others."
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-6295932396",
  email_address: "soubhagyag73@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "@Sou_bha_gya", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
